<template>
  <div id="legal" class="legal-section">
    <section class="hero is-medium is-primary null-bg">
      <h1>{{ $t("LEGAL_ADVISOR_TITLE") }}</h1>
      <h2>{{ $t("LEGAL_ADVISOR_SUBTITLE") }}</h2>
      <h3>{{ $t("LEGAL_ADVISOR_0_TITLE") }}</h3>
      <p v-html="parseMessageToHtml('LEGAL_ADVISOR_0_TEXT')" />
      <ol>
        <li>
          {{ $t("LEGAL_ADVISOR_1_TITLE") }}
          <ol>
            <li v-html="parseMessageToHtml('LEGAL_ADVISOR_1_1_TEXT')" />
            <li v-html="parseMessageToHtml('LEGAL_ADVISOR_1_2_TEXT')" />
            <li v-html="parseMessageToHtml('LEGAL_ADVISOR_1_3_TEXT')" />
          </ol>
        </li>
        <li>
          {{ $t("LEGAL_ADVISOR_2_TITLE") }}
          <ol>
            <li v-html="parseMessageToHtml('LEGAL_ADVISOR_2_1_TEXT')" />
            <li v-html="parseMessageToHtml('LEGAL_ADVISOR_2_2_TEXT')" />
          </ol>
        </li>
        <li>
          {{ $t("LEGAL_ADVISOR_3_TITLE") }}
          <ol>
            <li v-html="parseMessageToHtml('LEGAL_ADVISOR_3_1_TEXT')" />
            <li
              v-html="
                parseWordForLink(
                  'LEGAL_ADVISOR_3_2_TEXT',
                  $t('COOKIE_POLICY'),
                  $t('COOKIE_POLICY_URL')
                )
              "
            />
            <li v-html="parseMessageToHtml('LEGAL_ADVISOR_3_3_TEXT')" />
            <li
              v-html="
                parseWordForMailTo(
                  'LEGAL_ADVISOR_3_4_TEXT',
                  'lopd@isglobal.org'
                )
              "
            />
          </ol>
        </li>
      </ol>
      <br />
      <p v-html="parseMessageToHtml('LEGAL_ADVISOR_UPDATE_DATE')" />
    </section>
  </div>
</template>

<script>
export default {
  name: "Legal",
  methods: {
    parseMessageToHtml(key) {
      return this.$t(key).replace(/\n/g, "<br />");
    },
    parseWordForLink(key, word, url) {
      const linkTag = '<a href="' + url + '" target="_blank">' + word + "</a>";
      return this.parseMessageToHtml(key).replace(word, linkTag);
    },
    parseWordForMailTo(key, mail) {
      const mailTag =
        '<a href="mailto:' + mail + '" target="_blank">' + mail + "</a>";
      return this.parseMessageToHtml(key).replace(mail, mailTag);
    }
  }
};
</script>
